import React from "react";
import { PageHeaderSection } from "../components";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import config from "../config/Main.json"

const Terms: React.FunctionComponent = () => {
  const { t } = useTranslation("terms");

  const subTitleStyle: React.CSSProperties = {
    fontSize: "2rem",
    fontWeight: 300,
    margin: "calc(2rem - .14286em) 0 1rem",
    color: "#000000de",
    fontFamily: "Avenir Next Codensed Ultralight",
  };

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontSize: "1.2rem",
    fontWeight: 200,
    color: "#342714"
  };

  return (
    <Container>
      <PageHeaderSection
        id={"section_start"}
        headline={t("headline-scope")}
        subheadline={t("headline")}
        content={<p style={{ ...contentStyle, textAlign: "left" }}>{t("scope", { company: config.company })}</p>}
      />
      <div style={contentStyle}>
        <h2 style={subTitleStyle}>{t("headline-contract")}</h2>
        <p>{t("contract-content-01")}</p>
        <p>{t("contract-content-02")}</p>
        <p>{t("contract-content-03")}</p>
        <p>{t("contract-content-04")}</p>
        <p>{t("contract-content-05")}</p>
        <p>{t("contract-content-06")}</p>
        <p>{t("contract-content-07")}</p>
        <h2 style={subTitleStyle}>{t("headline-availability")}</h2>
        <p>{t("availability-content")}</p>
        <h2 style={subTitleStyle}>{t("headline-prices")}</h2>
        <p>{t("prices-content")}</p>
        <h2 style={subTitleStyle}>{t("headline-payment")}</h2>
        <p>{t("payment-content")}</p>
        <h2 style={subTitleStyle}>{t("headline-warranty")}</h2>
        <p>{t("warranty-content")}</p>
        <h2 style={subTitleStyle}>{t("headline-cancellation")}</h2>
        <p>{t("cancellation-content-01")}</p>
        <p>{t("cancellation-content-02")}</p>
        <p>{t("cancellation-content-03")}</p>
        <p>{t("cancellation-content-04")}</p>
        <p>{t("cancellation-content-05")}</p>
        <p>{config.company}</p>
        <p>{config.streetAddress}</p>
        <p>{config.postalCode} {config.locality}</p>
        <p>{t("cancellation-content-06")}</p>
      </div>
    </Container>
  );
}

export default Terms;
